import { HtmlId } from '../enum';
import { createNotification } from '@vfde-brix/ws10/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { mountComponent } from '../util/mount';

export const mountNotification = (id: HtmlId) =>
    mountComponent(id, createNotification, NO_PATTERN_BUSINESS_LOGIC);
